export default
{
  missing: ['Ainda não tenho esta informação... ', 'I do not have this information yet...', 'todavía no tengo esta información...'],
  desc1: ['Que tal realizarmos o seu Teste de Cor para (juntas) descobrirmos as cores que mais valorizam o seu tom de pele e te deixam ainda mais linda?', 'that we perform your test of Color to (together) discover the colors that most value your skin tone and make you even more beautiful', 'Que tal realizarmos to prueba de color para (juntas) descobrir los colores que más valoran tu tono de piel y dejan aún más linda'],
  notConfig: [
    'Ainda não conhece o resultado da sua Coloração Pessoal?\nVem comigo e vamos juntas colorir seu guarda-roupa!',
    'Still don\'t know the result of your Personal Coloring?\nCome with me and let\'s color your wardrobe together!',
    '¿Todavía no sabes el resultado de tu coloración personal?\n¡Ven conmigo y coloreamos tu guardarropa juntos!'
  ],
  notConfSendLink: ['Clica aqui', 'Click here', 'Haga clic aquí'],
  notConfSendMessage: [
    ' e me envia um WhatsApp!',
    ' and send me a WhatsApp!',
    ' y envíame un WhatsApp!'
  ],
  definition: ['Definição', 'Definition', 'Definition'],
  monochromatic: ['Monocromática', 'Monochromatic', 'Monochromatic'],
  bicolor: ['Bicolor', 'Bicolor', 'Bicolor'],
  complementary: ['Complementar', 'Complementary', 'Complementary'],
  analogous: ['Análoga', 'Analogous', 'Analogous'],
  triad: ['Tríade', 'Triad', 'Triad'],
  noProducts: [
    'Não existem produtos nessa categoria.',
    'There are no products in this category.',
    'No hay productos en esta categoría'
  ],
  colorMatcher: [
    'primavera_quente',
    'primavera_brilhante',
    'primavera_clara',
    'outono_suave',
    'outono_escuro',
    'outono_quente',
    'inverno_brilhante',
    'inverno_frio',
    'inverno_escuro',
    'verao_frio',
    'verao_claro',
    'verao_suave'
  ],
  contrast: [
    ['Alto Contraste', 'High Contrast', 'Alto Contraste'],
    ['Médio Contraste', 'Medium Contrast', 'Contraste Medio'],
    ['Baixo Contraste Claro', 'Low Light Contrast', 'Contraste de poca luz'],
    ['Baixo Contraste Escuro', 'Low Dark Contrast', 'Contraste oscuro bajo'],
    ['Médio Contraste Para Alto', 'Medium High Contrast', 'Contraste medio alto'],
    ['Médio Contraste Para Baixo', 'Medium Low Contrast', 'Contraste medio bajo']
  ],
  onlineCard: [
    'Cartela Online',
    'Online Card',
    'Tarjeta Online'
  ]
}



// WEBPACK FOOTER //
// ./src/constants/Cromatica.js